import axios from "axios";

export default function EntrylocationDeniedEmployeesService(formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/employee/deniedEmployees",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
